import { Locale, type LocalizedString } from "../Locale.js";
import { ProductFilling } from "../ProductFilling.js";

export const productFillingNameMap = {
	[ProductFilling.ChocolateWithRaspberries]: { [Locale.cs]: "Čokoládový s malinami" },
	[ProductFilling.ChocolateWithSaltedCaramel]: { [Locale.cs]: "Čokoládový se slaným karamelem" },
	[ProductFilling.FruityDark]: { [Locale.cs]: "Ovocný – tmavý" },
	[ProductFilling.FruityLight]: { [Locale.cs]: "Ovocný – světlý" },
	[ProductFilling.LemonWithRaspberries]: { [Locale.cs]: "Citrónový s malinami" },
	[ProductFilling.PistachioWithRaspberries]: { [Locale.cs]: "Pistáciový s malinami" },
} satisfies Record<ProductFilling, LocalizedString>;
